const getPriceForPack = (packSize, packageTypes)=>{
    const matchedVariant = packageTypes.find((packageType)=>packageType.packageQuantity === packSize
    );
    // not using multiple prices for now
    return matchedVariant && matchedVariant.price;
};

export { getPriceForPack };
//# sourceMappingURL=get-price-for-pack.js.map
